import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class Navbar extends Controller {
  static targets = ['navbar', 'menu', 'burger']
  static values = {
    opened: { type: Boolean, default: false }
  }

  connect () {
    if (!this.hasMenuTarget) return

    useClickOutside(this, { element: this.menuTarget })
  }

  openedValueChanged (value) {
    if (!this.hasMenuTarget) return

    if (value === true) {
      this.menuTarget.classList.add('navbar__menu-active')
      this.#toggleBackdrop()
    } else {
      this.menuTarget.classList.remove('navbar__menu-active')
      this.#toggleBackdrop()
    }
  }

  open () {
    this.openedValue = true
  }

  close () {
    this.openedValue = false
  }

  clickOutside (event) {
    if (this.burgerTarget.contains(event.target)) return

    if (this.openedValue === true) {
      event.preventDefault()
      this.openedValue = false
    }
  }

  #toggleBackdrop () {
    const container = this.navbarTarget
    let backdrop = container.querySelector('.backdrop')

    if (this.openedValue) {
      if (!backdrop) {
        setTimeout(() => {
          backdrop = document.createElement('div')
          backdrop.classList.add('backdrop')
          container.appendChild(backdrop)
        }, 150)
      }
    } else {
      if (backdrop) {
        container.removeChild(backdrop)
      }
    }
  }
}
